module.exports = __webpack_public_path__ + "static/media/msg-locked.baf20cfe.svg";